import { v4 as uuidv4 } from "uuid";

export class ReferenceModel {
	_id?: string;
	referenceTitle?: string;
	referenceForename?: string;
	referenceForenameError?: string;
	referenceSurname?: string;
	referenceSurnameError?: string;
	referenceCompany?: string;
	referencePosition?: string;
	referenceEmail?: string;
	referenceEmailError?: string;
	referenceTelephone?: string;
	referenceTelephoneError?: string;
	referenceType?: number;
	referenceTypeError?: string;
	referenceId?: string;
	referenceDuration?: string;
	referenceDurationError?: string;
	dateFrom?: string;
	dateTo?: string;
	referenceApply?: boolean;
	referenceNote?: string;
	referenceState?: string;

	constructor(data: any = {}) {
		if (data._id) this._id = data._id;
		this.referenceTitle = data.referenceTitle || "";
		this.referenceForename = data.referenceForename || "";
		this.referenceSurname = data.referenceSurname || "";
		this.referenceCompany = data.referenceCompany || "";
		this.referencePosition = data.referencePosition || "";
		this.referenceEmail = data.referenceEmail || "";
		this.referenceTelephone = data.referenceTelephone || "";
		this.referenceType = data.referenceType || null;
		this.referenceId = data.referenceId || uuidv4();
		this.referenceDuration = data.referenceDuration || "";
		this.referenceApply = data?.referenceApply !== null && data?.referenceApply !== undefined ? data?.referenceApply : false;
		this.dateFrom = data?.dateFrom || "";
		this.dateTo = data?.dateTo || "";
		this.referenceNote = data.referenceNote || "";
		this.referenceState = data.referenceState || "";
	}
}
